<template>
  <b-card no-body>
    <b-card-header>
      <h3 class="mb-0">{{ title }}</h3>
      <small><em>*Current month highlighted.</em></small>
    </b-card-header>
    <monthly-summary-table :period="period" :items="items" v-if="items"></monthly-summary-table>
    <loading-panel v-else></loading-panel>
  </b-card>
</template>

<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin';
import LoadingPanel from '@/components/LoadingPanel';
import MonthlySummaryTable from '@/views/Components/Tables/MonthlySummaryTable';

export default {
  mixins: [errorsMixin],
  components: {
    LoadingPanel,
    MonthlySummaryTable
  },
  props: {
    period: null,
    year: null
  },
  data() {
    return {
      items: null
    }
  },
  computed: {
    userRoute() {
      return this.$store.getters['profile/userRoute'];
    },
    title() {
      return (this.period == 'monthly') ? 'Monthly Summary' : 'Quarterly Summary';
    }
  },
  methods: {
    async getItems() {
      axios.get(this.userRoute + "/ceo-summary?period=" + this.period + "&year=" + this.year)
        .then(response => {
          this.items = response.data;
        })
        .catch(error => {
          this.error(error);
        });
    }
  },
  created() {
    this.getItems();
  },
  watch: {
    period(to, from) {
      this.getItems();
    },
    year(to, from) {
      this.getItems();
    }
  }
};
</script>